var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.model && _vm.model.IsSuccess)?_c('div',[_c('employee-detail',{attrs:{"employee":_vm.model.Value}}),_vm._v(" "),_c('hr')],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }